<template>
  <div>
    <v-alert
      class="mx-auto"
      max-width="800"
      border="bottom"
      colored-border
      outlined
      dense
      type="info"
      color="fadein"
      v-if="visible"
    >
      <div v-for="(msg, index) in messages" :key="index">{{ msg }}</div>
    </v-alert>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "Messages",
  data: () => ({
    visible: false,
  }),
  computed: {
    ...mapGetters({
      messages: "gMessages",
    }),
  },
  watch: {
    /* messages: function () {
      if (this.messages.length) {
        this.visible = true;
      } else {
        this.visible = false;
      }
    }, */
  },
};
</script>

<style>
</style> 